module.exports = __webpack_public_path__ + "img/logo.891334c5.jpg";